import { FormController } from '../classes/form-controller';
const axios = require('axios');

export default class extends FormController {
	static targets = ['form', 'field', 'input', 'successNotice', 'errorNotice', 'codeError'];

	connect() {
		// Call connect from FormController
		super.connect();
	}

	/**
	 * Submit shop form.
	 */
	submit(e) {
		e.preventDefault();
		const formData = new FormData(this.formTarget);

		if(!this.codeErrorTarget.classList.contains('hidden')) {
			this.codeErrorTarget.classList.add('hidden');
		}

		this.formTarget.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.formTarget.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					if (response.data.code_amount_left !== undefined) {
						// Not enough codes available.
						// Show error with amount of codes left
						let content = this.codeErrorTarget.dataset.content;
						content = content.replace('[codes]', response.data.code_amount_left);
						this.codeErrorTarget.innerHTML = content;
						this.codeErrorTarget.classList.remove('hidden');
						this.formTarget.removeAttribute('data-group-loading');
					} else if (response.data.mollie_url !== undefined) {
						document.location.href = response.data.mollie_url;
					}
				}
			})
			.catch((error) => {
				console.log(error);
				this.formTarget.removeAttribute('data-group-loading');
			});
	}
}
